export default __webpack_public_path__ + "static/media/medical-logo.e769ace7.png";